//
//
//
//
//
//
//
//
//

export default {
    name: 'App',
    methods: {
        toKF() {
            window.location.href = 'https://im.7x24cc.com/phone_webChat.html?accountId=N000000003098&chatId=5bc9746d-b49e-4a28-a96f-c437e6faae80'
        },
        getUrlParams(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
            var r = window.location.search.substr(1).match(reg)
            return r && r[2]
        },
        getUrlKey() {
            var url = window.location.href
            if (url.split('?')[1] !== undefined) {
                var key = url.split('?')[1].split('?')[0] ? url.split('?')[1].split('?')[0].split('&')[0].split('=')[0] : ''
                return key
            }
        },
        getParams() {
            let url = decodeURIComponent(window.location.href)
            if (url.includes('?')) {
                let source = {}
                let arr = url.slice(url.indexOf('?') + 1).split('&')
                arr.forEach(item => {
                    let param = item.split('=')
                    source[param[0]] = param[1]
                })
                if (source.utm_source === 'baidu-m') {
                    sessionStorage.setItem('source', JSON.stringify(source))
                }
                if (source.bd_vid) {
                    localStorage.setItem('bd_vid', source.bd_vid)
                    localStorage.setItem('url', url)
                }
            }
        }
    },
    mounted() {
        this.getParams()
        if (window.wxCode) {
            this.$http.get('/weChat/getOpenIdByAppId', {
                params: {
                    code: window.wxCode,
                    appId: 'wx118eeaa85fba4416'
                }
            }).then(res => {
                if (res.data.code === 200 && res.data.status === 1) {
                    sessionStorage.setItem('rose-openid', res.data.data.openId)
                }
            })
        }
        // 亿起发 cps 第三方广告推广记录
        let yqfaid = this.getUrlParams('aid')
        if (yqfaid) {
            const cps = {
                aid: yqfaid,
                channel: this.getUrlParams('channel') || '',
                cid: this.getUrlParams('cid') || '',
                wi: this.getUrlParams('wi') || '',
                target: this.getUrlParams('target') || 'https://m.roseonly.com.cn'
            }
            sessionStorage.setItem('cps', JSON.stringify(cps))
        }
        let sourceKey = this.getUrlKey()
        sessionStorage.setItem('sourceKey', sourceKey)
    }
}
